import Image from 'next/image'
import s from './preloader.module.scss'
import {Flex} from 'antd'
import cat from './cat-round.png'
import {useEffect, useState} from "react";

export const Preloader = () => {
    const [show, setShow] = useState(true);

    useEffect(() => {
        const timeout = setTimeout(() => {
            setShow(false)
        }, 3000);

        return () => {
            clearTimeout(timeout);
        }
    }, [show]);

    if (process.env.NODE_ENV !== 'production'){
        return null
    }

    return show
        ? <div className={s.preloader}>
            <div className={s.main}>
                {/*<div className={s.header}>*/}
                {/*    Don't Look Up!*/}
                {/*</div>*/}
                <div className={s.content}>
                    <div className={s.image_wrapper}>
                        <div className={s.loader}>

                        </div>
                        <Image
                            width={200}
                            height={200}
                            alt='cat'
                            src={cat.src}
                            priority
                        />
                    </div>
                    <Flex
                        vertical
                        align='center'
                        gap={12}
                    >
                        <div className={s.logo_text}>
                            <span>save the cat</span>Ⓡ
                        </div>
                        <p>Software that unlocks your story</p>
                    </Flex>
                    <p
                        style={{ fontSize: '20px', fontWeight: 700 }}
                    >
                        Hang in there!
                    </p>
                </div>
            </div>
        </div>
        : null
}